import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import { domainName } from "../../../utility/index"
import moment from "moment";

export default {
    name: "ContractManagement",
    components: { tree, iTable, IPagination },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                contractId: '',
                supplierName: '',
                warrantyTime: '',
                signTime: [],
            },
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [
                {
                    prop: "contractId",
                    label: this.$t('ContractManagement.contractId'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "typeName",
                    label: this.$t('ContractManagement.typeName'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "supplierName",
                    label: this.$t('ContractManagement.supplierName'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "contactName",
                    label: this.$t('ContractManagement.contactName'),
                    align: "center",
                    width: "120px"
                },

                {
                    prop: "phone",
                    label: this.$t('ContractManagement.phone'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "signTime",
                    label: this.$t('ContractManagement.signTime'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "warrantyTime",
                    label: this.$t('ContractManagement.warrantyTime'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "isWarranty",
                    label: this.$t('ContractManagement.isWarranty'),
                    align: "center",
                    width: "120px",
                    render: (h, params) => {
                        return h('el-tag', {
                          props: { type: params.row.isWarranty === '' ? '' : params.row.isWarranty === 0 ? 'success' : 'info' }
                        }, params.row.isWarranty === '' ? '' : params.row.isWarranty === 0 ? this.$t('common.search.inWarranty') : this.$t('common.search.outWarranty'))
                      }

                },
                {
                    prop: "contractMoney",
                    label: this.$t('ContractManagement.contractMoney'),
                    align: "center",
                    width: "120px"
                }
            ],
            dialogDetailsFormVisible:false,
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        method: (index, row) => {
                            this.dialogDetailsFormVisible = true
                            this.queryDetails(index, row)
                        }
                    }
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            dialogFormVisible: false,
            formLabelWidth: '112px',
            diaTitle: '',
            btnType: '',
            rules: {
                orgId: [
                    { required: true, message: this.$t('common.form.orgTip'), trigger: 'blur' }
                ],
                contractId: [
                    { required: true, message: this.$t('ContractManagement.form.contractIdTip'), trigger: 'blur' }
                ],
                signTime: [
                    { required: true, message: this.$t('ContractManagement.form.signTimeTip'), trigger: 'change' }
                ],
                warrantyTime: [
                    { required: true, message: this.$t('ContractManagement.form.warrantyTimeTip'), trigger: 'change' }
                ],
            },
            form: {
                orgId: '',
                contractId: '',
                type: '',
                contractMoney: '',
                signTime: '',
                warrantyTime: '',
                contactName: '',
                phone: '',
                supplierName: '',
                remarks: '',
                filePath: ''
            },
            DetailsRorm: {
                orgId: '',
                contractId: '',
                type: '',
                contractMoney: '',
                signTime: '',
                warrantyTime: '',
                contactName: '',
                phone: '',
                supplierName: '',
                remarks: '',
            },
            selected: [],
            id: '',
            name: '',
        }
    },
    created() {
        
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getContract()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getContract()
        },
        getContract() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.signTime) {
                if (this.formInline.signTime.length > 0) {
                    startTime = this.formInline.signTime[0]
                    endTime = this.formInline.signTime[1]
                }
            }
            let param = {
                orgId: this.id,
                contractId: this.formInline.contractId,
                supplierName: this.formInline.supplierName,
                isWarranty: this.formInline.warrantyTime,
                startSignTime: startTime,
                endSignTime: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('ContractManagement/GET_QUERYCONTRACT', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        res.data.data.list.map(item => {
                            item.signTime = item.signTime ? moment(item.signTime).format("YYYY-MM-DD") : ''
                            item.warrantyTime = item.warrantyTime ? moment(item.warrantyTime).format("YYYY-MM-DD") : ''
                        })
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getContract()
        },
        onClear() {
            this.formInline = {
                contractId: '',
                supplierName: '',
                warrantyTime: '',
                signTime: [],
            }
            this.getContract()
        },
        addContract() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'add'
            this.form.orgId = this.name
            this.form.filePath = ''
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        orgId: this.id,
                        contractId: this.form.contractId,
                        type: this.form.type,
                        contractMoney: this.form.contractMoney,
                        signTime: this.form.signTime,
                        warrantyTime: this.form.warrantyTime,
                        contactName: this.form.contactName,
                        phone: this.form.phone,
                        supplierName: this.form.supplierName,
                        remarks: this.form.remarks,
                        filePath: this.form.filePath,
                    }
                    this.$store.dispatch('ContractManagement/GET_INSERTCONTRACT', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.addSuccess'))
                            this.dialogFormVisible = false;
                            this.getContract();
                            this.closeDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })



                }
            });
        },
        uploadFile(e) {
            let dom = document.getElementById('uploadDom')
            let file = dom.files[0];
            let formData = new FormData()
            formData.append('file', file)
            formData.append('path', 'contract')
            this.$store.dispatch('FileController/GET_UPLOADCONTRACTFILE', formData).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(this.$t('common.btn.fileUploadSuccess'))
                    this.form.filePath = res.data.data[0]
                } else {
                    this.$message.error(res.data.msg)
                }
            }).catch(err => {
                this.$message.error(this.$t('common.btn.fileUploadError'))
                document.getElementById('uploadDom').value = ''
            })
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                contractId: '',
                type: '',
                contractMoney: '',
                signTime: '',
                warrantyTime: '',
                contactName: '',
                phone: '',
                supplierName: '',
                remarks: '',
                filePath: ''
            }
        },
        closeDia() {
            this.DetailsRorm = {
                contractId: '',
                type: '',
                contractMoney: '',
                signTime: '',
                warrantyTime: '',
                contactName: '',
                phone: '',
                supplierName: '',
                remarks: '',
                filePath: ''
            }
            this.dialogFormVisible = false;
        },
        queryDetails(index, row){
            console.log(row)
            this.DetailsRorm = {
                orgId: row.orgName,
                contractId: row.contractId,
                type: row.typeName,
                contractMoney: row.contractMoney,
                signTime: row.signTime,
                warrantyTime: row.warrantyTime,
                contactName: row.contactName,
                phone: row.phone,
                supplierName: row.supplierName,
                remarks: row.remarks,
            }
        },
        deleteContract() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.tip'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { id: this.selected.map(item => item.id).join() }
                    this.$store.dispatch('ContractManagement/GET_DELETECONTRACT', param).then(response => {
                        if (response.data.code == 200) {
                            this.getContract()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        downFile() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/FileController/getFile?filePath=${this.selected[0].filePath}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/FileController/getFile?filePath=${this.selected[0].filePath}`
                    location.href = url
                }
            }
        },
        closeDetailsDia(){
            this.form = {
                contractId: '',
                type: '',
                contractMoney: '',
                signTime: '',
                warrantyTime: '',
                contactName: '',
                phone: '',
                supplierName: '',
                remarks: '',
                filePath: ''
            }
            this.dialogDetailsFormVisible = false;
        },
        
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getContract();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}